export default __webpack_public_path__ + "static/media/woman.6d3bf6bf.webp";